export const equalsOrContains = (field, value) =>
  value === field || (Array.isArray(value) && value.indexOf(field) !== -1);



// WEBPACK FOOTER //
// ./src/modules/employment-helper.js